import { StockResearchTrendAction } from './stock-research-trend.action';

export class StockResearchTrendState {
    trend: any;
    companyTrend: any;
    pending: boolean;
    error: null;
    islittletraded: any;
    shortTrend: any;
}

export const initialGenericState: StockResearchTrendState = {
    trend: '',
    companyTrend: '',
    pending: false,
    error: null,
    islittletraded: null,
    shortTrend: ''
}

export function StockResearchTrendReducer(state: StockResearchTrendState = initialGenericState, action: any){

    switch (action.type) {

        case StockResearchTrendAction.getTrend:
            return { ...{}, ...state, ...{ pending: true, error: null } };
        case StockResearchTrendAction.getTrendSuccess:
            return { ...{}, ...state, ...{ pending: false, error: null, trend: action.payload } };
        case StockResearchTrendAction.getTrendError:
            return { ...{}, ...state, ...{ pending: false, error: action.payload } };

        case StockResearchTrendAction.getShortTrend:
            return { ...{}, ...state, ...{ pending: true, error: null } };
        case StockResearchTrendAction.getShortTrendSuccess:
            return { ...{}, ...state, ...{ pending: false, error: null, shortTrend: action.payload } };
        case StockResearchTrendAction.getShortTrendError:
            return { ...{}, ...state, ...{ pending: false, error: action.payload } };

        case StockResearchTrendAction.getCompanyTrend:
            return { ...{}, ...state, ...{ pending: true, error: null } };
        case StockResearchTrendAction.getCompanyTrendSuccess:
            return { ...{}, ...state, ...{ pending: false, error: null, companyTrend: action.payload } };
        case StockResearchTrendAction.getCompanyTrendError:
            return { ...{}, ...state, ...{ pending: false, error: action.payload } };

        case StockResearchTrendAction.getLittleTraded:
            return { ...{}, ...state, ...{ pending: true, error: null } };
        case StockResearchTrendAction.getLittleTradedSuccess:
            return { ...{}, ...state, ...{ pending: false, error: null, islittletraded: action.payload } };
        case StockResearchTrendAction.getLittleTradedError:
            return { ...{}, ...state, ...{ pending: false, error: action.payload } };

        default:
            return state;
    }

}